export const getData = state => state.hereMap.get('data')
export const getDataFetching = state => state.hereMap.get('fetching')
export const getDataError = state => state.hereMap.get('error')

export const getPreferences = state => state.hereMap.getIn(['preferences', 'objects'])
export const getPreferencesFetching = state => state.hereMap.getIn(['preferences', 'saving'])
export const getCustomerAddressTypes = state => state.hereMap.get('customer_address_types')
